import React from "react";
import { Link } from "react-router-dom";

interface Error404Props {
  imageSrc: string;
  title?: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
  buttonClassName?: string;
}

const Error404: React.FC<Error404Props> = ({
  imageSrc,
  title = "Page non trouvée",
  description = "La page que vous recherchez n'existe pas.",
  buttonText = "Menu principal",
  buttonLink = "/comingSoon",
  buttonClassName = "md:w-1/4 w-4/5 border-2 /lg:-translate-y-16 mx-auto /translate-y-44 hover:bg-blue-500 p-2 lg:text-base bg-radio text-center lg:py-2 lg:px-4 rounded-full uppercase md:text-xs"
}) => {
  return (
    <div className="h-screen overflow-hidden">
      <div className="md:w-4/5 lg:mt-0 mt-44 w-full mx-auto">
        <img src={imageSrc} alt="Erreur 404" />
        <div className="flex flex-col items-center justify-center h-full space-y-4">
         
          <div className={buttonClassName}>
            <Link
              to={buttonLink}
              className="no-underline text-white font-semibold"
            >
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404; 